import fetcherApi from '../components/FetcherApi.jsx';
import urlTools from "components/tools/urlTools.jsx";

const PhysicalCardConfirmationService = {
  async confirmPhysicalCard(cardPrefix, cardNumber) {
    const confirmationResult = { isConfirmed: false, error: '' };
    if (!this.isCardFormatValid(cardPrefix, cardNumber)) {
      confirmationResult.error = "card_replacement_page_incorrect_card_number_error"
    }
    else {      
      const payload = {
        cardPrefix: cardPrefix,
        cardNumber: cardNumber
      };

      const result = (await fetcherApi.post(
        urlTools.constructRoute("api/Profile/PhysicalCard/confirm"), 
        payload)).response;
      if (result.data.success) {
        confirmationResult.isConfirmed = true;
      }
      else if (result.data.error === 'replacingCardWithInitialStatus') {
        confirmationResult.error = 'enter_existing_card_page_initial_card_error'
      } else if (result.data.error === "cardIsVirtual") {
        confirmationResult.error = 'enter_existing_card_virtual_card_entered_error';
      } else if (result.data.error === "rate_limit_reached") {
        confirmationResult.error = 'enter_existing_card_page_rate_limit_reached';
      } else if (result.data.error === "cardNotFound") {
        confirmationResult.error = 'card_replacement_page_incorrect_number_field_error';
      } else if (result.data.error === "cardNumberIsBlocked") {
        confirmationResult.error = 'card_replacement_page_blocked_card_error';
      } else if (result.data.error === 'attemptingToRegisterConfirmedCard') {
        confirmationResult.error = 'account_found_page_info';
      }
      else {
        confirmationResult.error = 'enter_existing_card_page_card_not_found_error';
      }
    }

    return confirmationResult;
  },
  isCardFormatValid(cardPrefix, cardNumber) {
    console.log(cardPrefix, cardNumber);
    return cardPrefix?.length === 11 && cardNumber?.length === 8;
  }
}

export default PhysicalCardConfirmationService;